module.exports = __webpack_public_path__ + "static/img/coupons-bg.446bcff.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/collectCustomerInfo/studentDriver/static/coupons-bg.png
// module id = xDUG
// module chunks = 1